import { BrandName } from '@seek/je-shared-data/lib/types/brand';

/**
 * Determines whether to show the benefit for x times more candidate
 * views.
 *
 * @param {BrandName} params.brand - The brand name.
 * @returns {boolean} Returns true if the benefit should be shown, false
 * otherwise.
 */
export const showXTimesMoreCandidateViews = ({
  brand
}: {
  brand: BrandName;
}): boolean => {
  if (brand === BrandName.JOBSTREETEXPRESS) return true;
  if (brand === BrandName.JOBSDB) return true;
  if (brand === BrandName.JORA) return true;

  return false;
};
